export const VETTING_META = {
  approved:       { label: 'Approved',       tint: '#15803d', bg: '#dcfce7', desc: 'You’ve checked this supplier and they’re cleared to be given work.' },
  pending_review: { label: 'Pending review', tint: '#d97706', bg: '#fef3c7', desc: 'Nobody has checked this supplier yet. Approve them once you’re happy with their insurance and competence.' },
  probationary:   { label: 'Probationary',   tint: '#c2410c', bg: '#ffedd5', desc: 'On a trial period. Allowed to work, but being watched closely before full approval.' },
  suspended:      { label: 'Suspended',      tint: '#b00020', bg: '#fdecea', desc: 'Stopped from being given any new work. Suspended suppliers can’t be assigned tasks.' },
}

export const DOC_TINT = {
  insurance:  '#33becc',
  competence: '#7C5FE0',
  rams:       '#d97706',
  other:      '#9aa0aa',
}

const toVettingKey = status =>
  (status || '').replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase()

export const vettingMeta = status => {
  const key = toVettingKey(status)
  return VETTING_META[key] || {
    label: (key || 'unknown').replace(/_/g, ' ').replace(/^./, ch => ch.toUpperCase()),
    tint: '#9aa0aa',
    bg: '#f1f5f9',
    desc: '',
  }
}
